export default {
  RecentSearchProvider__INVALID_TIMESTAMP: "Invalid timestamp",
};
